const { handlersError } = await import('../utils/handler-listener-error');

// eslint-disable-next-line func-names
(function () {
  window.addEventListener('error', (event) => {
    handlersError(event);
  });
  window.addEventListener('unhandledrejection', (event) => {
    handlersError(event);
  });
})();
